import './App.css';
import Main from "./comp/Main";
import History from "./comp/History";
import Goods from "./comp/Goods";
import Bus from "./comp/Bus"

import {BrowserRouter, Route, Switch, NavLink } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <nav>
        <NavLink exact to="/sevenstar"><img src={require("./img/logo.png").default} alt=""/></NavLink>
        <NavLink to ="/sevenstar">칠성사이다 70주년</NavLink>
        <NavLink to="/history">70년 히스토리</NavLink>
        <NavLink to="/goods">칠성사이다 Goods</NavLink>
        <NavLink to="/bus">리그린 버스정류장</NavLink>
      </nav>
      <Switch>
        <Route exact path="/sevenstar"><Main/></Route>
        <Route path="/history"><History/></Route>
        <Route path="/goods"><Goods/></Route>
        <Route path="/bus"><Bus/></Route>
      </Switch>
      <footer><img src={require("./img/footer_logo.png").default} alt=""/>Copyright © 2020 LOTTE CHILSUNG BEVERAGE CO.,LTD. ALL RIGHTS RESERVED</footer>
    </BrowserRouter>
  );
}

export default App;
